import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { ActivatedRoute } from '@angular/router';
import { IExtendPagination } from 'src/app/shared/Pagination/IPagination';
import { HomeService } from 'src/app/shared/services/home.service';
import { Product } from '../../../../shared/classes/product';

@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss']
})
export class GridComponent implements OnInit {

  @Input() products: Product[] = [];
  @Input() paginate: any = {};
  @Input() layoutView: string = 'grid-view';
  @Input() sortBy: string;
  @Input() filterBy: string;
  @Input() pagination: IExtendPagination;
  @Input() totalCount: number;

  @Input() filterHidden: boolean;
  @Input() paginationHidden: boolean;


  @Output() setGrid: EventEmitter<any> = new EventEmitter<any>();
  @Output() setLayout: EventEmitter<any> = new EventEmitter<any>();
  @Output() sortedBy: EventEmitter<any> = new EventEmitter<any>();
  @Output() filteredBy: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() paginationOutput: EventEmitter<any> = new EventEmitter<any>();

  paginationValue: any;



  constructor(private _activatedRoute: ActivatedRoute,
    private _homeService: HomeService) { }

  ngOnInit(): void {
  }

  setGridLayout(value: string) {
    this.setGrid.emit(value);  // Set Grid Size
  }

  setLayoutView(value: string) {
    this.layoutView = value
    this.setLayout.emit(value); // Set layout view
  }

  sorting(event) {
    this.sortedBy.emit(event.target.value)
  }

  onFilterBy(event) {
    var filterValue = event.target.value;
    this.filteredBy.emit(filterValue)
  }



  switchPage(event: PageEvent, searchQuery: string = '') {

    // eslint-disable-next-line no-debugger

    this.pagination = {
      currentPage: event.pageIndex + 1,
      pageSize: event.pageSize
    };

    this.paginationValue = { currentPage: event.pageIndex + 1, pageSize: event.pageSize };
    this.paginationOutput.emit(this.paginationValue);

    // const slug = this._activatedRoute.snapshot.paramMap.get('slug');
    // this._homeService.brandsList(slug,this.pagination).subscribe();
  }


}
